import { otto } from "@gr-exports/async/nexus";
import { defineStore } from "@gr-common/async/nexus";
import { hashParams, searchParams } from "./data/params";
import { initScopes, scope } from "./lib/scope";
import { getCurrentNavigation, initNavigationEvents } from "./lib/navigation";
import { patchHistory } from "./lib/history";
import { NAV_SCOPES } from "./lib/utils";
import { locationState } from "./data/state";
import type { StateRecord } from "./data/state.types";
import type { NavigationScopeOptions, NavigationScopeState } from "./lib/scope.types";
import type { NavigationCurrentState } from ".";

const [url, state, hash, search] = getCurrentNavigation();

otto.navigation.assignNamespace(
  {
    current: defineStore<NavigationCurrentState>({
      url,
      state,
      hash,
      search,
      type: "push",
    }),
    currentUrl: defineStore(url),
    currentState: defineStore(state),
    currentHash: defineStore(hash),
    currentSearch: defineStore(search),

    /*                         */

    hashParams,
    searchParams,

    scope,

    /*                                                                          */
    [NAV_SCOPES]: {
      global: {
        current: defineStore<NavigationScopeState<NavigationScopeOptions>>({
          state: locationState<StateRecord>(state),
          hash,
          search,
          type: "push",
          url,
        }),
        currentState: defineStore(locationState<StateRecord>(state)),
        currentHash: defineStore(hash),
        currentSearch: defineStore(search),
      },
    },
  },
  { lock: import.meta.env.VITE_OTTO_IS_TESTING_BUNDLE !== "true" },
);

patchHistory();
initNavigationEvents();

/*                                                                    */
/*                                                                             */
initScopes();
